import { Controller } from '@hotwired/stimulus';
import { createPopper } from '@popperjs/core';

export default class extends Controller {
    connect() {
        const data = this.element.dataset;
        const offsetX = Number(data.offsetX) || 0;
        const offsetY = Number(data.offsetY) || 0;
        const arrowLeft = data.arrowLeft;

        this.tooltip = this.element.querySelector('.tooltip');
        const arrowElement = this.tooltip ? this.tooltip.querySelector('.tooltip-arrow') : null;

        if (this.tooltip) {
            document.body.appendChild(this.tooltip);
        }

        ['mouseenter', 'touchstart'].forEach(evt =>
            this.element.addEventListener(evt, (e) => {
                if (this.popperInstance) {
                    this.popperInstance.destroy();
                }

                const modifiers = [
                    {
                        name: 'offset',
                        options: {
                            offset: [offsetX, offsetY],
                        },
                    },
                    {
                        name: 'preventOverflow',
                        options: {
                            padding: 10,
                            boundary: 'viewport',
                        },
                    }
                ];

                if (!arrowLeft && arrowElement) {
                    modifiers.push({
                        name: 'arrow',
                        options: {
                            element: arrowElement,
                            padding: 8,
                        },
                    });
                }

                this.popperInstance = createPopper(this.element, this.tooltip, {
                    placement: 'top',
                    modifiers: modifiers,
                });

                this.tooltip.style.display = 'block';

                if (arrowLeft && arrowElement) {
                    arrowElement.style.left = `${arrowLeft}px`;
                    arrowElement.style.transform = 'none';
                }

            }, { passive: true })
        );

        ['mouseleave', 'touchend'].forEach(evt =>
            this.element.addEventListener(evt, () => {
                if (this.tooltip) {
                    this.tooltip.style.display = 'none';
                }
            }, { passive: true })
        );
    }

    disconnect() {
        if (this.popperInstance) {
            this.popperInstance.destroy();
        }
        if (this.tooltip && this.tooltip.parentNode) {
            this.tooltip.parentNode.removeChild(this.tooltip);
        }
    }
}
